import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import { setupListeners } from "@reduxjs/toolkit/query";
import storage from "redux-persist/lib/storage";

// files
import { userReducer } from "./Slices";
import {
  adminsApi,
  projectsApi,
  coachesApi,
  managerApi,
  userApi,
  gymsApi,
  sportsApi,
  locationApi,
  uploadApi,
  plansApi,
  authApi,
  ratingApi,
  commentApi,
} from "./api";

// persist
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["userSlice"],
};

// combine Reducers
const rootReducer = combineReducers({
  // Slices
  userSlice: userReducer,
  // apis
  [adminsApi.reducerPath]: adminsApi.reducer,
  [projectsApi.reducerPath]: projectsApi.reducer,
  [coachesApi.reducerPath]: coachesApi.reducer,
  [managerApi.reducerPath]: managerApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [gymsApi.reducerPath]: gymsApi.reducer,
  [sportsApi.reducerPath]: sportsApi.reducer,
  [locationApi.reducerPath]: locationApi.reducer,
  [uploadApi.reducerPath]: uploadApi.reducer,
  [plansApi.reducerPath]: plansApi.reducer,
  [authApi.reducerPath]: authApi.reducer,
  [ratingApi.reducerPath]: ratingApi.reducer,
  [commentApi.reducerPath]: commentApi.reducer,
});

// Persist reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// creating Store
export const store = configureStore({
  reducer: persistedReducer,

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false })
      .concat(adminsApi.middleware)
      .concat(projectsApi.middleware)
      .concat(coachesApi.middleware)
      .concat(managerApi.middleware)
      .concat(gymsApi.middleware)
      .concat(userApi.middleware)
      .concat(sportsApi.middleware)
      .concat(locationApi.middleware)
      .concat(uploadApi.middleware)
      .concat(plansApi.middleware)
      .concat(authApi.middleware)
      .concat(ratingApi.middleware)
      .concat(commentApi.middleware),
});

setupListeners(store.dispatch);

// creating persist
export const persistor = persistStore(store);
